export default function AboutSection() {
  return (
    <section id="about" className="py-20 md:py-28 px-4 md:px-6 bg-accent-50/60">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
          <div className="lg:w-5/12">
            <p className="text-xs font-label tracking-widest uppercase text-accent-600 mb-4">
              / What is hipobuy sheet
            </p>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 leading-tight">
              What Is Hipobuy Spreadsheet?
            </h2>
          </div>

          <div className="lg:w-7/12 space-y-6">
            <p className="text-base md:text-lg text-foreground-700 leading-relaxed">
              <strong>Hipobuy Spreadsheet</strong> is a structured product research resource that helps shoppers organize, compare, and discover products more efficiently. Instead of manually searching through thousands of scattered listings across multiple platforms, users can explore organized categories, product information, quality guides, and comparison resources all in one unified destination.
            </p>
            <p className="text-base md:text-lg text-foreground-700 leading-relaxed">
              What makes the Hipobuy Spreadsheet approach different is its systematic categorization. Every product is carefully grouped into logical categories such as <strong>Shoes</strong>, <strong>Hoodies &amp; Sweaters</strong>, <strong>T-Shirts</strong>, <strong>Jackets</strong>, <strong>Pants &amp; Shorts</strong>, <strong>Headwear</strong>, and many more. This organized structure means you spend less time searching and more time finding exactly what you need.
            </p>
            <p className="text-base md:text-lg text-foreground-700 leading-relaxed">
              The platform also serves as a bridge to the broader shopping ecosystem, connecting users to resources covering related platforms including <strong>Kakobuy Spreadsheet</strong>, <strong>CSSBuy Spreadsheet</strong>, <strong>Superbuy Spreadsheet</strong>, and <strong>Oopbuy Spreadsheet</strong>. Whether you are a first-time explorer or an experienced shopper, the Hipobuy Spreadsheet provides a reliable starting point for informed product discovery.
            </p>

            <div className="pt-6 flex flex-wrap items-center gap-4">
              <div className="flex -space-x-2">
                <div className="w-10 h-10 rounded-full bg-primary-200 border-2 border-background-50"></div>
                <div className="w-10 h-10 rounded-full bg-accent-200 border-2 border-background-50"></div>
                <div className="w-10 h-10 rounded-full bg-secondary-200 border-2 border-background-50"></div>
                <div className="w-10 h-10 rounded-full bg-primary-300 border-2 border-background-50"></div>
              </div>
              <p className="text-sm text-foreground-600">
                <span className="text-foreground-900 font-semibold">Trusted by 10,000+ shoppers</span> — Verified guides for Kakobuy, CSSBuy, Superbuy &amp; Oopbuy spreadsheets.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}